// Shared so the card that renders the anchor and the banner that scrolls to it
// cannot drift apart.
export function specialistCardAnchorId(toolCallId: string): string {
  return `specialist-card-${toolCallId}`;
}
